// src/admin/adminApi.js

const API_URL =
  process.env.NODE_ENV === "production"
    ? (process.env.REACT_APP_API_URL || "https://api.hellastay.com")
    : "http://localhost:8000";

function getToken() {
  try {
    return localStorage.getItem("token") || "";
  } catch {
    return "";
  }
}

function withAuthHeaders(extra = {}) {
  const token = getToken();

  // ✅ hellastay uses httpOnly cookies first
  // Bearer token stays only as optional fallback
  return token
    ? { ...extra, Authorization: `Bearer ${token}` }
    : extra;
}

async function readError(response) {
  const ct = response.headers.get("content-type") || "";

  try {
    if (ct.includes("application/json")) {
      const data = await response.json();
      return data?.message
        ? String(data.message)
        : JSON.stringify(data);
    }

    const text = await response.text();
    return text || `Request failed (${response.status})`;
  } catch {
    return `Request failed (${response.status})`;
  }
}

async function parseResponse(response) {
  const ct = response.headers.get("content-type") || "";

  // some endpoints may return empty body
  if (response.status === 204) return null;

  try {
    if (ct.includes("application/json")) {
      return await response.json();
    }

    const text = await response.text();
    return text || null;
  } catch {
    return null;
  }
}

async function request(path, options = {}) {
  const response = await fetch(`${API_URL}${path}`, {
    credentials: "include",
    ...options,
    headers: withAuthHeaders(options.headers || {}),
  });

  if (!response.ok) {
    throw new Error(await readError(response));
  }

  return parseResponse(response);
}

export async function adminGet(path) {
  return request(path, {
    method: "GET",
  });
}

/**
 * ✅ Smart admin update
 * Tries PUT first, then falls back to PATCH
 */
export async function adminPatch(path, body) {
  const payload = JSON.stringify(body ?? {});
  const headers = { "Content-Type": "application/json" };

  try {
    return await request(path, {
      method: "PUT",
      headers,
      body: payload,
    });
  } catch (err) {
    const msg = String(err?.message || "");

    // fallback only when PUT is not supported / route differs
    if (!msg.includes("404") && !msg.includes("405")) {
      throw err;
    }
  }

  return request(path, {
    method: "PATCH",
    headers,
    body: payload,
  });
}

export async function adminDelete(path) {
  return request(path, {
    method: "DELETE",
  });
}